/* const namespaced = true;
 */
const state = {
	interface:{
		name:null,
		status:false,
	}
}

const mutations = {
	START_VIEW_GUIDE(state, payload){
		state.interface = {
			name: payload.name,
			status: payload.status,
		}
	}
}

const actions = {

}

export default {
    /* namespaced, */
    state,
    mutations,
    actions
}